import templateUrl from 'emun.salesrep/market-list.htm'
import controller from 'emun.salesrep/market-list.controller'

let MarketList = {
    bindings: {
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default MarketList;